import {styled} from '@esgi/ui/theme';

export const Ul = styled('ul', {
	listStyle: 'none',
	margin: 0,
	padding: 0,
	userSelect: 'none',
});
